module.exports = "<portlet-body>\n    <div class=\"padding-body\">\n        <ea-notification-page company-filter-enabled=\"$ctrl.companyFilterEnabled\"></ea-notification-page>\n    </div>\n</portlet-body>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaNotification/eaNotificationPage/eaNotificationPageModule.html
// module id = 1053
// module chunks = 12